import React from 'react';
import { cn } from '../../lib/utils';

export type OMEView = 'edit' | 'valuation' | 'tools';

export interface OMESidebarProps {
  currentView: OMEView;
  onViewChange: (view: OMEView) => void;
}

export default function OMESidebar({ currentView, onViewChange }: OMESidebarProps) {
  const [isCollapsed, setIsCollapsed] = React.useState(false);

  const navItems: { id: OMEView; label: string; icon: string }[] = [
    { id: 'edit', label: 'Edit', icon: 'edit_note' },
    { id: 'valuation', label: 'Valuation', icon: 'monitoring' },
    { id: 'tools', label: 'Tools', icon: 'construction' },
  ];

  return (
    <aside className={cn(
      "bg-white border-r border-slate-200 flex flex-col shrink-0 transition-all duration-300",
      isCollapsed ? "w-16" : "w-64"
    )}>
      {/* Header */}
      <div className="p-4 border-b border-slate-100 flex items-center justify-between">
        {!isCollapsed && (
          <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
            Operational Model
          </span>
        )}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="text-slate-400 hover:text-primary transition-colors"
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <span className="material-symbols-outlined text-sm">
            {isCollapsed ? 'chevron_right' : 'side_navigation'}
          </span>
        </button>
      </div>

      {/* Navigation items */}
      <nav className="flex-1 overflow-y-auto py-2">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onViewChange(item.id)}
            title={isCollapsed ? item.label : undefined}
            className={cn(
              'sidebar-item',
              currentView === item.id && 'active',
              isCollapsed && 'justify-center px-3'
            )}
          >
            <span className="material-symbols-outlined text-[20px]">{item.icon}</span>
            {!isCollapsed && (
              <span className="flex items-center gap-2 flex-1">
                {item.label}
              </span>
            )}
          </button>
        ))}
      </nav>
    </aside>
  );
}
